import React from 'react'
import '../../../assets/css/AboutSection.css'
const Uabout = () => {
    return (
        <div>
            <section class="about-section" id="about">
                <h2 class="about-title">About</h2>
                <p class="about-text">
                Introducing "U"-where elegance meets flair. Designed for the modern woman, "U" blends chic comfort with striking style, perfect for any occasion. With bold cuts, luxurious fabrics and meticulous detail, "U" lets you shine effortlessly, every day.
                </p>
            </section>

            <section class="innovation-banner">
                <h2 class="banner-title">Redefine Elegance, Own Every Moment.</h2>
            </section>


        </div>
    )
}

export default Uabout